import React from 'react'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { useGlobalCruisesSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalCruisesSearch'
import CruiseSearchBar from 'components/Cruises/SearchPage/CruiseSearchBar'

function GlobalCruisesSearchTabContent() {
  const { globalCruisesSearchDispatch, globalCruisesSearchState } = useGlobalCruisesSearchContext()

  return <GlobalSearchContextProvider
    state={globalCruisesSearchState}
    dispatch={globalCruisesSearchDispatch}
  >
    <CruiseSearchBar />
  </GlobalSearchContextProvider>
}

export default GlobalCruisesSearchTabContent
